import findCollection from "./findCollection";
import { db } from "../../../config/firebaseconfig";

export default function saveRecordChanges(record, data) {
  const { name, state, sfid, period } = data
  
  function checkForChanges(record, data, key) {
    if (record[key] === data[key]) {
      return false
    } else return true
  }

  let update = {}
  if (checkForChanges(record, data, 'state')) {
    update.state = state
  }
  if (checkForChanges(record, data, 'name')) {
    update.name = name
  }
  if (checkForChanges(record, data, 'sfid')) {
    update.sfid = sfid
  }
  if (checkForChanges(record, data, 'period')) {
    update.period = period
  }

  if (Object.keys(update).length === 0) {
    return Promise.reject('No changes to save.')
  }

  const collection = findCollection(record)
  if (!collection) {
    return Promise.reject('Invalid record.')
  }

  return db.collection(collection).doc(record.id).update(update)
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/saveRecordChanges.js